<template>
	<div
		id="modal-contact"
		class="modal fade"
		style="z-index: 10000;"
		data-bs-keyboard="false"
		tabindex="-1"
		aria-labelledby="staticBackdropLabel"
		aria-modal="true"
		role="dialog"
	>
		<div class="modal-dialog modal-lg my-2">
			<div class="modal-content custom-modal">
				<div class="row justify-content-center">
					<div class="col-10">
						<div class="d-flex align-items-center justify-between py-4">
							<p class="text-20 color-dark-blue extra-bold mb-0">
								Contacte o anunciante
							</p>
							<button
								type="button"
								class="btn-close"
								data-bs-dismiss="modal"
								aria-label="Close"
							/>
						</div>
					</div>
				</div>
				<div class="bg-my-account py-3">
					<div class="row justify-content-center">
						<div class="col-10">
							<p class="mb-0 text-18 color-black regular">
								{{ property.fake_title }}
							</p>
							<p class="text-16 color-blue bold mb-1">
								{{ property.price }}
							</p>
							<p class="mb-0 text-11 regular color-gray-AC">
								Ref. Externa: {{ property.external_ref }}
							</p>
						</div>
					</div>
				</div>

				<div class="row justify-content-center mt-4">
					<div class="col-10">
						<div id="scrolltocontact" class="">
							<FormContact
								ref="formContact"
								:endpoint="route('api.property.sendContactRequest', property.ad_id)"
								modal-identifier="#modal-contact"
							/>

							<div class="col-12 no-padding py-3">
								<hr style="width:100%;border:1px solid #ebebebb0;margin: 0px;">
							</div>

							<template v-if="property.showName">
								<div class="row py-2 px-0 px-lg-4 check-improxy_property align-items-center">
									<div class="col-6 col-md-6 pl-4 mb-4">
										<div style="margin-bottom: 20px;margin-top: 10px">
											<p class="extra-bold text-14 color-gray-AC mb-2">
												Anunciante {{ property.typeAd }}
											</p>
											<!--                                            <p class="bold responsive-text-16 color-gray-7070">-->
											<!--                                                <span>{{ property.agent_phone }}</span>-->
											<!--                                                <template v-if="!property.agent_phone && ! property.contacts.length">-->
											<!--                                                    - -->
											<!--                                                </template>-->

											<!--                                                <span v-for="phone in property.contacts">{{ phone }}</span>-->
											<!--                                            </p>-->
											<span v-if="property.agent_phone">
												<div class="d-flex  phone-pikaboo-wrapper phoneNumberDivVue" style="height:23px">
													<img
														style="width: 15px;margin-right: 2px;"
														:src="phoneIcon"
														alt="Phone"
													>
													<show-phone-number
														:id="property.ad_id"
														:phone="property.agent_phone"
														:ext-ref="property.external_ref"
														user-id=""
														modeltype="ads"
													/>
												</div>
												<span v-html="legislationString(property.agent_phone)" />
											</span>

											<span v-for="phone in property.contacts" :key="phone">
												<div class="d-flex  phone-pikaboo-wrapper phoneNumberDivVue" style="height: 23px;">
													<img
														style="width: 15px;margin-right: 2px;"
														:src="phoneIcon"
														alt="Phone"
													>
													<show-phone-number
														:id="property.ad_id"
														:phone="phone"
														:ext-ref="property.external_ref"
														user-id=""
														modeltype="ads"
													/>
												</div>
												<span v-html="legislationString(phone)" />
											</span>
										</div>
									</div>
									<div class="col-6 col-md-6 mb-4">
										<div class="">
											<div class="d-flex align-items-center justify-content-center">
												<template v-if="property.routeSlugAgent">
													<a :href="property.routeSlugAgent">
														<img
															:src="mainPhotoUrl"
															width="53"
															height="53"
															style="border-radius: 50%"
															alt="associated user"
															@error="errorImageUser"
														>
													</a>
												</template>
												<template v-else>
													<img
														:src="mainPhotoUrl"
														width="53"
														height="53"
														style="border-radius: 50%"
														alt="Main photo"
													>
												</template>
											</div>
										</div>
									</div>
									<template v-if="isImproxyOrExternal">
										<div class="col-6 col-md-6 pl-4">
											<div class="h-100">
												<p class="color-location responsive-text-14 regular mb-1">
													{{ property.subsidiary_name || '-' }}
												</p>
												<p class="light text-11 text-uppercase color-black">
													AMI
													{{ property.subsidiary_ami || '-' }}
												</p>
												<div v-if="property.subsidiary_mainphone" class="d-flex align-items-end h-25">
													<div class="d-flex  phone-pikaboo-wrapper phoneNumberDivVue" style="height: 23px;">
														<img
															style="width: 15px;margin-right: 2px;"
															:src="phoneIcon"
															alt="Photo"
														>
														<show-phone-number
															:id="property.ad_id"
															:phone="property.subsidiary_mainphone"
															:ext-ref="property.external_ref"
															user-id=""
															modeltype="ads"
														/>
													</div>
													<span v-html="legislationString(property.subsidiary_mainphone)" />
												</div>
											</div>
										</div>

										<div class="col-6 col-md-6">
											<div class="d-flex align-items-center justify-content-center">
												<img
													:src="property.subsidiary_logo"
													width="96"
													height="87"
													alt="Company"
												>
											</div>

											<div class="">
												<p class="text-11 semi-bold color-black text-center mt-3 mb-0">
													Ref. Externa:
													<b class=" light text-11 color-black">
														{{ property.external_ref || '-' }}
													</b>
												</p>
											</div>
										</div>
									</template>
								</div>
							</template>

							<template v-if="!isImproxyOrExternal && accountIsCompany">
								<div class="row py-2 px-0 px-lg-4 check-company_property">
									<div class="col-6 col-md-6 pl-4">
										<div class="">
											<p class="color-location responsive-text-14 regular mb-1">
												{{ companyName || '-' }}
											</p>
											<p class="light text-11 text-uppercase color-black">
												AMI
												{{ companyAmi || '-' }}
											</p>
										</div>
										<div class="">
											<p class="text-11 light color-black">
												Atividade
												<b class="semi-bold text-11 color-black">
													{{ companyActivity }}
												</b>
											</p>
										</div>
									</div>

									<div class="col-6 col-md-6">
										<template v-if="companyRouteSlug">
											<a data-modal-contact-slug-agency :href="companyRouteSlug ? companyRouteSlug : 'javascript:void(0)'">
												<div class="d-flex align-items-center justify-content-center">
													<template v-if="companyLogo">
														<img
															:src="companyLogo"
															width="76"
															height="67"
															:alt="companyName || 'Company logo'"
															data-origin="company_logo"
															@error="errorImage"
														>
													</template>
													<template v-else>
														<img
															:src="asset('images/noLogo.svg')"
															width="60"
															height="67"
															alt="No logo"
														>
													</template>
												</div>
											</a>
										</template>
										<template v-else>
											<div data-modal-contact-slug-agency :href="companyRouteSlug ? companyRouteSlug : 'javascript:void(0)'">
												<div class="d-flex align-items-center justify-content-center">
													<template v-if="companyLogo">
														<img
															:src="companyLogo"
															width="76"
															height="67"
															:alt="companyName || 'Company logo'"
															data-origin="company_logo"
															@error="errorImage"
														>
													</template>
													<template v-else>
														<img
															:src="asset('images/noLogo.svg')"
															width="60"
															height="67"
															alt="No logo"
														>
													</template>
												</div>
											</div>
										</template>
									</div>
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import FormContact from "@/vue/components/FormContact";
import basePropertyForContact from "@/vue/components/basePropertyForContact";
import {isUndefinedOrNull} from "tupy-helperjs";

export default {
    name: "ModalContact",
    components: {FormContact},
    props: {
        property: {
            type: Object,
            default: basePropertyForContact
        },
    },
    data() {
        return {}
    },
    computed: {
        accountIsCompany(){
            return this.property.ad_type !== 'external_property' && this.property.company
        },
        isImproxyOrExternal(){
            return ['improxy_property', 'external_property'].includes(this.property.ad_type)
        },
        companyAmi(){
            return this.property.company?.ami
        },
        companyRouteSlug(){
            return this.property.company?.link
        },
        companyLogo(){
            return this.property.company?.logo || this.subsidiary_logo
        },
        companyActivity(){
            return this.property.company?.company_activity || '-'
        },
        companyName(){
            return this.property.company?.company_name
        },
        urlAgent(){
            return this.property.routeSlugAgent || 'javascript:void(0)'
        },
        mainPhotoUrl(){
            if(! isUndefinedOrNull(this.property.agentAssociatedUser?.photo)) {
                return this.property.agentAssociatedUser.photo
            }

            if (! isUndefinedOrNull(this.property.photo)) {
                return this.property.photo
            }

            return this.asset('images/noImageUserMan.svg')
        },
        phoneIcon(){
            return this.asset('images/Phone.svg')
        }
    },
    methods: {
        errorImage($ev){
            $ev.target.src = this.asset('images/noLogo.svg');
        },
        errorImageUser($ev){
            $ev.target.src = this.asset('images/noImageUserMan.svg');
        },
        legislationString(number) {
            return HelperJS.legislationForPhoneN(number)
        }
    }
}
</script>

